"use client";
const p = {
  wrapper: "m-auto rounded-t-popup bg-popup top-auto max-h-[95dvh]",
  inner: "rounded-t-popup max-h-[inherit] pb-[calc(env(safe-area-inset-bottom)+var(--spacing-popup-padding-y))]"
}, o = "cursor-pointer !bg-foreground/40 duration-200 min-h-[5px] shrink-0", t = {
  overlay: "fixed inset-0 bg-popup-overlay backdrop-blur-popup-overlay",
  wrapper: {
    base: [
      "fixed inset-0 m-auto h-fit outline-none text-popup-foreground",
      "sm:max-w-popup-widht"
    ],
    variants: {
      bottom: p.wrapper,
      left: "right-auto bg-popup w-full h-dvh w-popup-widht max-w-9/10",
      right: "left-auto bg-popup w-full h-dvh w-popup-widht max-w-9/10",
      fixed: [
        "m-auto h-dvh flex items-center !pointer-events-none py-popup-padding-y px-popup-padding-x",
        "sm:px-0"
      ],
      auto: [
        p.wrapper,
        "sm:bg-transparent sm:bg-none sm:h-dvh sm:flex sm:items-center sm:!pointer-events-none sm:py-popup-padding-y sm:px-0 sm:max-h-[90dvh] sm:bottom-[5dvh]"
      ]
    }
  },
  inner: {
    base: [
      "transform-3d relative flex flex-col gap-popup-gap pointer-events-auto w-full bg-popup pt-popup-padding-y px-popup-padding-x h-auto max-h-full"
    ],
    variants: {
      bottom: p.inner,
      left: "h-full pb-popup-padding-y",
      right: "h-full pb-popup-padding-y",
      fixed: "pb-popup-padding-y rounded-popup pointer-events-auto opacity-0 duration-100 data-[open=true]:opacity-100",
      auto: [
        p.inner,
        "sm:pb-popup-padding-y sm:rounded-popup sm:pointer-events-auto sm:opacity-0 sm:duration-100 sm:data-[open=true]:opacity-100"
      ]
    }
  },
  handle: {
    left: "!hide",
    right: "!hide",
    fixed: "!hide",
    bottom: o,
    auto: [o, "sm:!hide"]
  }
};
export {
  t as stylesModal
};
